import { render, staticRenderFns } from "./FoodLinks.vue?vue&type=template&id=012c1b19&"
import script from "./FoodLinks.vue?vue&type=script&lang=ts&"
export * from "./FoodLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports